module.exports = __webpack_public_path__ + "img/20200429154833577.cec31edf.png";